<div class="row">
    <div class="col-3 col-sm-3 col-md-2">
        <kendo-menu [vertical]="true">
            <kendo-menu-item text="Home">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings')}">Home</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Action Types">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/action-types']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/action-types')}">Action Types</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Carrier Drop Reasons">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/carrier-drop-reasons']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/carrier-drop-reasons')}">Carrier Drop Reasons</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Carrier Services">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/carrier-services']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/carrier-services')}">Carrier Services</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Cities">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/cities']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/cities')}">Cities</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Employee">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/employees']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/employees')}">Employees</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Employee Groups">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/employee-groups']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/employee-groups')}">Employee Groups</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Employee Roles">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/employee-roles']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/employee-roles')}">Employee Roles</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Fuel Rates">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/fuel-rates']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/fuel-rates')}">Fuel Rates</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Industries">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/industries']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/industries')}">Industries</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Modes">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/modes']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/modes')}">Modes</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Opportunity Question Categories">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/opportunity-question-categories']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/opportunity-question-categories')}">Opportunity Question Categories</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Tag Types">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/tag-types']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/tag-types')}">Tag Types</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Tender Maintenance">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/tender-maintenance']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/tender-maintenance')}">Tender Maintenance</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Third Party Companies">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/third-party-companies']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/third-party-companies')}">Third Party Companies</a>
                </ng-template>
            </kendo-menu-item>
            <kendo-menu-item text="Trailer Types">
                <ng-template kendoMenuItemLinkTemplate>
                    <a [routerLink]="['/system-settings/trailer-types']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/system-settings/trailer-types')}">Trailer Types</a>
                </ng-template>
            </kendo-menu-item>
            <!--<kendo-menu-item text="Orders">
        <kendo-menu-item text="Order Entry">
            <ng-template kendoMenuItemLinkTemplate>
                <a [routerLink]="['/order-entry', 0]" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/order-entry/')}">Order Entry</a>
            </ng-template>
        </kendo-menu-item>
        <kendo-menu-item text="Planned Orders">
            <ng-template kendoMenuItemLinkTemplate>
                <a [routerLink]="['/order-planned']" class="k-link k-menu-link" [ngClass]="{'k-hover': isLinkActive('/order-planned')}">Planned Orders</a>
            </ng-template>
        </kendo-menu-item>
    </kendo-menu-item>-->
        </kendo-menu>
    </div>
    <div class="col-9 col-sm-9 col-md-10">
        <kendo-expansionpanel [title]="'Action Types'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/action-types')">
            <action-type-grid></action-type-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Carrier Drop Reasons'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/carrier-drop-reasons')">
            <carrier-drop-reason-grid></carrier-drop-reason-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Carrier Services'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/carrier-services')">
            <carrier-service-grid></carrier-service-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Cities'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/cities')">
            <city-form></city-form>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Employees'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/employees')">
            <employee-grid></employee-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Employee Groups'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/employee-groups')">
            <employee-group-grid></employee-group-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Employee Roles'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/employee-roles')">
            <employee-role-grid></employee-role-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Fuel Rates'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/fuel-rates')">
            <fuel-rate-grid></fuel-rate-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Industries'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/industries')">
            <industry-grid></industry-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Modes'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/modes')">
            <mode-grid></mode-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Opportunity Question Categories'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/opportunity-question-categories')">
            <opportunity-question-category-grid></opportunity-question-category-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Tag Types'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/tag-types')">
            <tag-type-grid></tag-type-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Tender Maintenance'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/tender-maintenance')">
            <tender-maintenance-form></tender-maintenance-form>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Third Party Companies'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/third-party-companies')">
            <third-party-company-grid></third-party-company-grid>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Trailer Types'"
                              [subtitle]="''"
                              [expanded]="true"
                              *ngIf="isLinkActive('/system-settings/trailer-types')">
            <trailer-type-grid></trailer-type-grid>
        </kendo-expansionpanel>
    </div>
</div>
